
import { BlogSection } from '@/types/blog';

export const mentaleFitnessSection: BlogSection = {
  id: 'mentale-fitness',
  title: 'Coaching als mentale und emotionale Fitness',
  content: `
    <p>
      Körperliche Fitness benötigt Training – das Gleiche gilt für unsere mentale und emotionale Widerstandskraft:
    </p>
    
    <div class="my-6 pl-4 border-l-4 border-primary/30 italic text-joerg-700">
      "Es geht nicht nur um das Lösen akuter Herausforderungen, sondern um eine langfristige Stärkung der mentalen und emotionalen Widerstandskraft."
    </div>
    
    <p>
      Coaching ist kein starres Konzept, sondern eine individuelle Reise, auf der:
    </p>
    
    <ul class="my-4 space-y-2">
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Fragen und aktives Zuhören den Klienten zu eigenen Lösungen führen</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Menschen befähigt werden, ihre eigenen Potenziale zu entfalten</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Persönliche Entwicklung und finanzielle Klarheit Hand in Hand gehen</span>
      </li>
    </ul>
    
    <p>
      Diese Philosophie teile ich vollkommen – im Finanzcoaching bedeutet das, Menschen zu unterstützen, 
      ihre finanziellen Entscheidungen selbstbestimmt und bewusst zu treffen.
    </p>
  `
};
